import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section data-testid="not-found" className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center max-w-xl">
        <div className="font-mono text-xs text-[#FFCC00] mb-3">ERROR 404</div>
        <h1 className="font-display text-5xl md:text-7xl font-bold uppercase">Off Route</h1>
        <p className="mt-4 text-white/65">This page isn&apos;t on the CLB Solution map.</p>
        <Link
          to="/"
          data-testid="not-found-home"
          className="mt-8 inline-flex items-center gap-2 bg-[#FFCC00] text-black font-bold uppercase tracking-[0.18em] text-xs px-6 py-4 hover:bg-[#E6B800] transition-colors"
        >
          Return Home
        </Link>
      </div>
    </section>
  );
}
